<template>
  <v-container>
    <v-combobox 
      clearable
      dense
      hide-selected 
      outlined
      v-model="selectedValue.Id"
      :items="items"
      item-text="NombreCompleto"
      item-value="Id"
      label="¿Para quién es el pase?" 
      persistent-hint 
      return-object 
      single-line 
      width="180"
      @change="emitValue"
      
    ></v-combobox>
  </v-container>
</template>

<script>
export default {
  name: "BeneficiadosComponent",
  props: {
    membresia: {
      type: String,
      default: '',
      required: true
    },
  },
  data() {
    return {
      selectedValue: { Id: null },
      items: [],
    };
  },
  watch: {
    membresia: {
      handler(newVal) {
        if (newVal) {
          this.selectedValue = { Id: null };
          this.getBeneficiarios(newVal);
        }
      },
      immediate: true
    }
  },
  methods: {
    emitValue() {
      this.$emit("value-changed", this.selectedValue.Id);
    },
    getBeneficiarios(membresiaId) {
      this.$http.get(`Membresia/beneficiados?membresia=${membresiaId}`)
        .then(response => {
          if (response.status === 200) {
            this.items = response.data.map(item => ({
                ...item,
                NombreCompleto: `${item.Nombres} ${item.Apaterno} ${item.Amaterno}`.trim()
              }))
          }
        })
        .catch(() => {
          this.items = [];
        });
    },
  },
};
</script>

<style scoped>
/* Estilos opcionales */
</style>
